<template>

    <div class="na-form">
        <div v-if="presentationGroupDetail" class="left">
            <DxTabPanel>
                <DxItem :title="captions.basicData">
                    <div class="dx-fieldset">


                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.presentGroup}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value="presentationGroupDetail.PgrName" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{captions.imgMaxSize}}:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value="presentationGroupDetail.PrgPreviewMaxSideSize"
                                             format="#0.## px" />
                            </div>
                        </div>


                    </div>
                    <div class="na-list">
                        <DxDataGrid v-model:data-source="pgrStatusList"
                                    :activeStateEnabled="true"
                                    :allowColumnReordering="true"
                                    :allowColumnResizing="true"
                                    :rowAlternationEnabled="true"
                                    @exporting="onExporting"
                                    :show-borders="true">
                            <DxEditing mode="cell"
                                       :allowUpdating="true"
                                       startEditAction="cell" />
                            <DxColumnChooser :enabled="true" />
                            <DxColumnFixing :enabled="true" />
                            <DxFilterPanel :visible="true" />
                            <DxFilterRow :visible="true" />
                            <DxHeaderFilter :visible="true" />
                            <DxSearchPanel :visible="true" placeholder="Search..." />
                            <DxLoadPanel :enabled="true" />
                            <DxScrolling row-rendering-mode="standard" />
                            <DxPaging :page-size="15" />
                            <DxPager :visible="true"
                                     :allowed-page-sizes="100"
                                     :display-mode="full"
                                     :show-page-size-selector="true"
                                     :show-info="true"
                                     :show-navigation-buttons="true" />
                            <DxSorting mode="multiple" />
                            <DxGroupPanel :visible="true" />
                            <DxStateStoring :enabled="true"
                                            type="localStorage"
                                            :storage-key="gridPgrKey" />
                            <DxExport :enabled="true"
                                      :allow-export-selected-data="true" />
                            <DxToolbar>
                                <DxItem name="groupPanel" />
                                <DxItem name="searchPanel" />
                                <DxItem name="exportButton" cssClass="mnExport" showText="false" />
                                <DxItem name="columnChooserButton"
                                        locate-in-menu="auto"
                                        location="after" />
                            </DxToolbar>

                            <DxColumn caption='ID' data-type="number" data-field='StatusId' :width="100" :visible="false" :allow-editing="false" />
                            <DxColumn :caption='columns.colStatus' data-type='string' data-field='StatusName' :allow-editing="false" />
                            <DxColumn :caption='columns.colSelected' data-type='boolean' data-field='Selected' :allow-editing="true" />
                            <DxColumn caption='Workflow' data-type='string' data-field='WorName' group-index="0" :allow-editing="false" />


                        </DxDataGrid>
                    </div>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              :text="btn.saveBtn"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              :text="btn.deleteBtn"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              :text="btn.backBtn"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxScrolling,
        DxSorting,
        DxPaging,
        DxPager,
        DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxToolbar,
        DxEditing,
        DxItem,
        DxExport
    } from 'devextreme-vue/data-grid'
    import { DxButton } from 'devextreme-vue/button'
    import { DxNumberBox } from 'devextreme-vue/number-box'
    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxTabPanel } from 'devextreme-vue/tab-panel'
    /* import { confirm } from "devextreme/ui/dialog"*/
    import $ from 'jquery'

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    export default {
        name: 'PresentationGroupDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxScrolling,
            DxSorting,
            DxPaging,
            DxPager,
            DxColumn,
            DxFilterPanel,
            DxStateStoring,
            DxGroupPanel,
            DxToolbar,
            DxItem,
            DxEditing,
            DxExport,
            DxNumberBox,
            DxTabPanel,
        },
        data() {
            return {
                captions: {
                    presentGroup: this.$LanguageProvider.GetResource("IresGroup", "Caption", "Name der Präsentationsgruppe"),
                    imgMaxSize: this.$LanguageProvider.GetResource("ImgMaxSize", "Caption", "Maximale Bildgröße in der Kachelansicht"),
                    basicData: this.$LanguageProvider.GetResource("BasicData", "Caption", "Basisdaten")
                },
                columns: {
                    colSelected: this.$LanguageProvider.GetResource("ColSelected", "Caption", "Ausgewählt"),
                    colStatus: this.$LanguageProvider.GetResource("ColStatus", "Caption", "Status"),
                },
                btn: {
                    saveBtn: this.$LanguageProvider.GetResource("SaveBtn", "Caption", "Speichern"),
                    deleteBtn: this.$LanguageProvider.GetResource("DeleteBtn", "Caption", "Löschen"),
                    backBtn: this.$LanguageProvider.GetResource("BackBtn", "Caption", "Zurück"),
                }
            };
        },
        props: {
            pgrId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            presentationGroupDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && oldVal != newVal) {
                    this.$store.state.presentationStore.presentationGroupDetailChanged = true
                }
            },
            pgrStatusListText: function (newVal, oldVal) {
                if (oldVal != "[]" && oldVal != newVal) {
                    this.$store.state.presentationStore.pgrStatusListChanged = true
                }
            },
        },
        created: function () {
        },
        mounted: function () {
            this.$store.dispatch("getPresentationGroupDetail", { pgrId: this.pgrId })
            this.$store.dispatch("getPgrStatusList", { pgrId: this.pgrId })
        },
        computed: {
            presentationGroupDetail() {
                return this.$store.state.presentationStore.presentationGroupDetail
            },
            pgrStatusList() {
                return this.$store.state.presentationStore.pgrStatusList
            },
            presentationGroupDetailText() {
                return JSON.stringify(this.$store.state.presentationStore.presentationGroupDetail)
            },
            pgrStatusListText() {
                return JSON.stringify(this.$store.state.presentationStore.pgrStatusList)
            },
            changed() {
                return this.$store.state.presentationStore.presentationGroupDetailChanged ||
                    this.$store.state.presentationStore.pgrStatusListChanged
            },
            saveButtonType() {
                return this.changed
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed
                    ? false : true
            },
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate(); 
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () { 
                    e.component.endUpdate();
                });
            },
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.$store.dispatch("savePresentationGroupDetail")
            },
            onDeleteClick() {
                //let result = confirm("Sind Sie sicher, dass Sie den Status löschen möchten? Ein Löschen ist nicht möglich, wenn bereits verknüpfte Datensätze bestehen", "Löschen bestätigen");
                //result.then((dialogResult) => {
                //    if (dialogResult) {
                //        this.$store.dispatch("deleteStatusDetail")
                //    }
                //});
            },
        }
    }
</script>
<style>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }

    .html-dx-field {
        width: 700px;
        height: 300px;
    }

    .html-label {
        padding-right: 200px
    }
</style>
